import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id  : 0,
        project_id  : 0,
        feedback_id : 0,
        window_x    : 0,
        window_y    : 0,
        window_top  : 0,
        window_left : 0,
        url         : '',
        name        : '',
        website_url : '',
        is_approved : false,
        approved_by : 0,
        upload_time : 0
    }
});